<template>
  <div>
    <!-- 海报html -->
    <div ref="posterHtml" class="posterHtml ignore" v-if="posterData && show">
      <img class="poster-bg ignore" :src="posterData.posterTplImg" alt="" crossOrigin="anonymous">
      <div class="poster-user ignore" v-if="posterData.user">
        <div class="poster-user__hd ignore">
          <img class="ignore" :src="posterData.user.avatar" alt="" crossOrigin="anonymous">
        </div>
        <div class="poster-user__bd ignore">
          <p class="poster-user__bd-title ignore">我是 {{posterData.user.nickname}}</p>
          <p class="poster-user__bd-desc ignore">我觉得这个课程超棒，推荐给你！</p>
        </div>
      </div>
      <div ref="qrcode" id="qrcode" class="ignore"></div>
    </div>
    <!-- 海报图片 -->
    <van-popup class="posterPopup" v-model="showPosterPopup" :close-on-click-overlay="false">
      <div class="poster-text">
        <span>96%的家长</span>转发后成功获取奖学金<br><span>长按图片保存海报</span>
      </div>
      <div class="poster-img">
        <img :src="posterImg" alt="">
      </div>
      <div class="poster-close" @click="closePosterPopup">
        <van-icon name="close" color="#fff" size="36" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
export default {
  name: 'Poster',
  props: {
    show: Boolean,
    posterData: Object
  },
  data() {
    return {
      posterImg: '',
      showPosterPopup: false
    }
  },
  watch: {
    show(value) {
      console.log('watch', value)
      if (value) {
        this.createPoster()
      }
    }
  },
  mounted() {

  },
  methods: {
    closePosterPopup() {
      this.showPosterPopup = false
      this.$emit('close')
    },
    imgLoad(imgurl) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(imgurl)
        img.onerror = () => reject(new Error(imgurl + ' load error'))
        img.src = imgurl
        img.crossOrigin = 'Anonymous'
      })
    },
    getBase64(url, outputFormat = 'image/png') {
      return new Promise((resolve, reject) => {
        let canvas = document.createElement('CANVAS')
        let ctx = canvas.getContext('2d')
        let img = new Image()

        img.crossOrigin = 'Anonymous'
        img.onload = () => {
          canvas.height = img.height
          canvas.width = img.width
          ctx.drawImage(img, 0, 0)
          let dataURL = canvas.toDataURL(outputFormat)
          canvas = null
          resolve(dataURL)
        }
        img.src = url
      })
    },
    imgReady() {
      const self = this
      let arr = [self.getBase64(self.posterData.posterTplImg)]
      if (self.posterData.user) {
        arr.push(self.getBase64(self.posterData.user.avatar))
      }

      return Promise.all(arr)
    },
    async createPoster() {
      // 生成海报
      const self = this
      if (!self.posterData.posterTplImg) {
        self.$toast.fail('无海报模板，生成失败！')
        self.closePosterPopup()
        return
      }
      self.$toast({
        type: 'loading',
        mask: true,
        message: '海报生成中...',
        duration: 0
      })
      let currentScrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      document.documentElement.scrollTop = 0
      window.pageYOffset = 0
      document.body.scrollTop = 0

      let res = await self.imgReady()
      console.log(res)
      self.posterData.posterTplImg = res[0]
      if (self.posterData.user) {
        self.posterData.user.avatar = res[1]
      }
      self.$nextTick(() => {
        const domObj = self.$refs.posterHtml
        self.createQrcode(self.posterData.wxShareLink)
        setTimeout(() => {
          html2canvas(domObj, {
            dpi: window.devicePixelRatio * 2,
            scale: 2,
            width: domObj.offsetWidth,
            heigth: domObj.offsetHeight,
            useCORS: true,
            allowTaint: true,
            logging: true,
            letterRendering: true
          }).then(canvas => {
            self.posterImg = canvas.toDataURL('image/png')
            self.showPosterPopup = true
            document.documentElement.scrollTop = currentScrollTop
            window.pageYOffset = currentScrollTop
            document.body.scrollTop = currentScrollTop
            console.log(self.posterImg)
            self.$toast.clear()
          }).catch(err => {
            self.$toast.clear()
            self.$toast('生成失败')
            console.log(err)
            self.$sentry.captureException(err)
          })
        }, 500)
      })
    },
    createQrcode(text) {
      console.log('------text', text)
      // 生成二维码
      const qrcodeImgEl = this.$refs.qrcode
      qrcodeImgEl.innerHTML = ''
      let qrcode = new QRCode(qrcodeImgEl, {
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcode.makeCode(text)
    }
  }
}
</script>
<style lang="scss" scoped>
  .posterHtml.ignore{
    position: fixed;
    width: 750px;
    top: 0;
    left: -1500px;
    z-index: 999;
    .poster-bg.ignore{
      width: 750px;
    }
    .poster-user.ignore{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      padding: 30px;
      display: flex;
      align-items: center;
      .poster-user__hd.ignore{
        margin-right: 20px;
        img.ignore{
          width: 100px;
          height: 100px;
          border-radius: 50px;
        }
      }
      .poster-user__bd.ignore{
        flex: 1;
        .poster-user__bd-title.ignore{
          color: #000;
          font-size: 32px;
          font-weight: 500;
        }
        .poster-user__bd-desc.ignore{
          color: #000;
          font-size: 26px;
          padding-top: 16px;
        }
      }
    }
    #qrcode.ignore{
      width: 200px;
      height: 200px;
      position: absolute;
      bottom: 40px;
      right: 40px;
      img.ignore{
        width: 100%;
        height: 100%;
      }
    }
  }
  .posterPopup{
    background: none;
    width: 100%;
    .poster-img{
      width: 70%;
      margin: 0 auto;
      img{
        width: 100%;
      }
    }
    .poster-text{
      color: #000;
      text-align: center;
      font-weight: bold;
      font-size: 20px;
      line-height: 32px;
      padding-bottom: 10px;
      text-shadow: 3px 3px 0 #fff, 3px 2px 0 #fff, 3px 1px 0 #fff, 3px 0 0 #fff, 3px -1px 0 #fff, 3px -2px 0 #fff, 3px -3px 0 #fff, 2px 3px 0 #fff, 2px 2px 0 #fff, 2px 1px 0 #fff, 2px 0 0 #fff, 2px -1px 0 #fff, 2px -2px 0 #fff, 2px -3px 0 #fff, 1px 3px 0 #fff, 1px 2px 0 #fff, 1px 1px 0 #fff, 1px 0 0 #fff, 1px -1px 0 #fff, 1px -2px 0 #fff, 1px -3px 0 #fff, 0 3px 0 #fff, 0 2px 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 0 -2px 0 #fff, 0 -3px 0 #fff, -3px 3px 0 #fff, -3px 2px 0 #fff, -3px 1px 0 #fff, -3px 0 0 #fff, -3px -1px 0 #fff, -3px -2px 0 #fff, -3px -3px 0 #fff, -2px 3px 0 #fff, -2px 2px 0 #fff, -2px 1px 0 #fff, -2px 0 0 #fff, -2px -1px 0 #fff, -2px -2px 0 #fff, -2px -3px 0 #fff, -1px 3px 0 #fff, -1px 2px 0 #fff, -1px 1px 0 #fff, -1px 0 0 #fff, -1px -1px 0 #fff, -1px -2px 0 #fff, -1px -3px 0 #fff;
      span{
        color: #ff4200;
      }
    }
    .poster-close{
      text-align: center;
      padding-top: 10px;
    }
  }
</style>
